import { Frequency } from '@lendi/core-constants';

import { FIELD_PATHS, INCOME_TYPE } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { IncomeEntityIndex } from '@funnels/types';

import { DropdownField } from '../../Fields';

const OPTIONS = [
  { label: 'PAYG base salary', value: INCOME_TYPE.PAYG_BASE_SALARY },
  { label: 'Bonus', value: INCOME_TYPE.PAYG_BONUS_INCOME },
  { label: 'Commission', value: INCOME_TYPE.PAYG_COMMISSION_INCOME },
  { label: 'Overtime', value: INCOME_TYPE.PAYG_OVERTIME_INCOME },
  { label: 'Car allowance', value: INCOME_TYPE.PAYG_CAR_ALLOWANCE },
  { label: 'Work allowance (taxed)', value: INCOME_TYPE.PAYG_ALLOWANCES_TAXED },
  { label: 'Work allowance (non-taxed)', value: INCOME_TYPE.PAYG_ALLOWANCES_NOT_TAXED },
  { label: 'Company car', value: INCOME_TYPE.PAYG_COMPANY_CAR },
  { label: 'Non-voluntary deductions (pre-tax)', value: INCOME_TYPE.PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX },
  { label: 'Salary sacrifice', value: INCOME_TYPE.PAYG_SALARY_SACRIFICE },
];

interface EmploymentIncomeTypeProps extends IncomeEntityIndex {
  shouldHideSalaryOption?: boolean;
  isDisabled?: boolean;
  isOptional?: boolean;
  disableFailMessage?: boolean;
}

export const EmploymentIncomeType = (props: EmploymentIncomeTypeProps) => {
  const { incomeIndex, shouldHideSalaryOption = false, ...rest } = props;
  const [, setFormValue] = useFormValues();

  const handleChange = ([value]: string[]) => {
    if (value === INCOME_TYPE.PAYG_COMPANY_CAR) {
      setFormValue(FIELD_PATHS.INCOME_AMOUNT(incomeIndex), 0);
      setFormValue(FIELD_PATHS.INCOME_FREQUENCY(incomeIndex), Frequency.Yearly);
    }
  };

  return (
    <DropdownField
      {...rest}
      name={FIELD_PATHS.INCOME_TYPE(incomeIndex)}
      options={OPTIONS.filter((option) => !shouldHideSalaryOption || option.value !== INCOME_TYPE.PAYG_BASE_SALARY)}
      onChange={handleChange}
      shouldAnchorList
    />
  );
};
